import React from 'react';
import { OrderLocation } from '../types';

export type LocationCellProps = OrderLocation;

export const LocationCell: React.FC<LocationCellProps> = ({ addressLine1, storeId, storeName }) => {
  if (addressLine1) {
    return <span className="sui-text-sm sui-text-subtle">{addressLine1}</span>;
  }

  if (storeName || storeId) {
    return <span className="sui-text-sm sui-text-subtle">{storeName ?? `Store #${storeId}`}</span>;
  }

  return null;
};
